module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/006_Excursuses#fm-1"
    }
  }, [_vm._v("List of Excursuses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/007_General#fm-2"
    }
  }, [_vm._v("General Editor’s Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Abbreviations#fm-3"
    }
  }, [_vm._v("List of Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Bibliography#fm-4"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#ch-1"
    }
  }, [_vm._v("INTRODUCTION TO EZRA AND NEHEMIAH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec-1"
    }
  }, [_vm._v("I. T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EXT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-1"
    }
  }, [_vm._v("A. Language")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-2"
    }
  }, [_vm._v("B. Sources")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-3"
    }
  }, [_vm._v("C. Sections")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec3-1"
    }
  }, [_vm._v("1. Ezra Memoir")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec3-2"
    }
  }, [_vm._v("2. Nehemiah Memoir")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec3-3"
    }
  }, [_vm._v("3. Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-4"
    }
  }, [_vm._v("D. Canonicity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec-2"
    }
  }, [_vm._v("II. D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ATE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-5"
    }
  }, [_vm._v("A. Order")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-6"
    }
  }, [_vm._v("B. Ezra-Nehemiah and Chronicles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-7"
    }
  }, [_vm._v("C. Separate Authorship Theory")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-8"
    }
  }, [_vm._v("D. Compilation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec-3"
    }
  }, [_vm._v("III. M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ETHODOLOGY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec-4"
    }
  }, [_vm._v("IV. S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ETTING")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-9"
    }
  }, [_vm._v("A. Yehud")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-10"
    }
  }, [_vm._v("B. Jerusalem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-11"
    }
  }, [_vm._v("C. Literary Criticism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec3-4"
    }
  }, [_vm._v("1. Themes and Purpose")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec3-5"
    }
  }, [_vm._v("2. Literary Techniques")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec3-6"
    }
  }, [_vm._v("3. Literature and History")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-12"
    }
  }, [_vm._v("D. Social Science")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec-5"
    }
  }, [_vm._v("V. P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ERSIAN")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ULE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-13"
    }
  }, [_vm._v("A. History vs. Historicity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-14"
    }
  }, [_vm._v("B. Cyrus II (559–530 BCE)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec3-7"
    }
  }, [_vm._v("1. The Conquests of Cyrus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec3-8"
    }
  }, [_vm._v("2. The Jews under Cyrus’s Rule")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-15"
    }
  }, [_vm._v("C. Darius I (522–485 BCE)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec3-9"
    }
  }, [_vm._v("1. The Reign of Darius I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec3-10"
    }
  }, [_vm._v("2. The Jews under Darius I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-16"
    }
  }, [_vm._v("D. Artaxerxes I (465–424 BCE)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec3-11"
    }
  }, [_vm._v("1. Artaxerxes Longimanus I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec3-12"
    }
  }, [_vm._v("2. Artaxerxes and Ezra")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec3-13"
    }
  }, [_vm._v("3. Artaxerxes and Nehemiah")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-17"
    }
  }, [_vm._v("E. Internal Jewish Leadership")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec-6"
    }
  }, [_vm._v("VI. S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ECOND")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EMPLE")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UDAISM")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-18"
    }
  }, [_vm._v("A. Monotheism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-19"
    }
  }, [_vm._v("B. Torah")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec3-14"
    }
  }, [_vm._v("1. Torah for Everyone")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec3-15"
    }
  }, [_vm._v("2. Heritage: What Was Ezra’s Torah?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec3-16"
    }
  }, [_vm._v("3. Legacy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-20"
    }
  }, [_vm._v("C. Sanctuary: The Second Temple")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec2-21"
    }
  }, [_vm._v("D. Holy People")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec-7"
    }
  }, [_vm._v("VII. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HRISTIAN")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PPLICATION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01#sec-8"
    }
  }, [_vm._v("VIII. O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UTLINE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Part01#pt-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE BOOK OF EZRA")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TEXT AND COMMENTARY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I. F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ROM")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ABYLONIAN")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("XILES TO")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EMPLE")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMMUNITY")]), _vm._v(" (1:1–6:22)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec2-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Return to Jerusalem (1:1–2:70)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec3-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Preparation for Return (1:1–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. Imperial Authorization (1:1–4)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Enthusiastic Response and Financial Support (1:5–6)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. Return of the Sacred Vessels (1:7–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec3-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Genealogical Record of the Returnees (2:1–70)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. Returnees by Descent (2:1–20)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Returnees by City (2:21–35)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. Temple and Related Personnel (2:36–58)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d. Undocumented Israelites/Priests (2:59–63)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("e. Total Returnees and Animals (2:64–67)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("f. Financial Donations and Conclusion (2:68–70)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec2-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Rebuilding the Temple (3:1–6:22)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec3-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Rebuilding the Foundations (3:1–13)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. Rebuilding and Dedicating the Altar (3:1–6)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Laying the Temple Foundations (3:7–13)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec5-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(1) Requisition of Materials (3:7)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec5-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(2) Commencement of the Work (3:8–9)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec5-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(3) Laying the Foundations amid Worship (3:10–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec5-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(4) Mixed Emotions (3:12–13)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec3-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Opposition to the Building Effort (4:1–6:22)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. The Local Population Rejected (4:1–3)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Opposition Begins (4:4–6)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec4-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. Aramaic Letters of Opposition and Suspension During the Time of Artaxerxes I (4:7–24)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec5-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(1) The Letter of Bishlam, Mithredath, and Tabeel (4:7)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec5-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(2) The Letter of Rehum and Shimshai (4:8–16)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02a#sec5-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(3) Artaxerxes’s Response (4:17–24)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec4-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d. Encouragement of the Prophets (5:1–2)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec4-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("e. Tattenai’s Complaint (5:3–17)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec5-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(1) Interrogation of the Builders (5:3–5)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec5-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(2) Letter to Darius Requesting an Investigation (5:6–17)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec4-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("f. Darius’s Decrees (6:1–12)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec5-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(1) Cyrus’s Edict Is Found in the Archives (6:1–5)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec5-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(2) Order to Complete the Temple with Imperial Aid (6:6–10)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec5-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(3) Threats for Neglecting or Changing the Decree (6:11–12)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec4-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("g. Completion and Dedication of the Temple (6:13–18)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec4-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("h. Celebration of the Passover and the Festival of Unleavened Bread (6:19–22)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("INISTRY OF")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ZRA")]), _vm._v(" (7:1–10:44)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec2-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Ezra’s Authorization (7:1–28)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec3-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Introduction to Ezra (7:1–10)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec4-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. Ezra’s Genealogy (7:1–5)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec4-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Ezra’s Mission (7:6–10)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec3-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The Commission of Ezra by Artaxerxes I (7:11–26)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec3-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Ezra’s Praise to Yahweh (7:27–28)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec2-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Ezra’s Journey to Jerusalem (8:1–36)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec3-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. List of Returning Families (8:1–14)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec3-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Assembly of the People and Search for Levites (8:15–20)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec3-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Fasting and Prayer (8:21–23)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec3-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Commissioning the Priests and Levites with Sacred Valuables (8:24–30)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec3-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The Journey from the River Ahava to Jerusalem (8:31–34)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec3-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Worship at the Temple and Delivery of the Imperial Orders (8:35–36)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec2-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. The Intermarriage Crisis (9:1–10:44)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec3-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Ezra’s Trauma (9:1–15)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec4-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. Elders Inform Ezra of the Sacrilege of “Holy Seed” (9:1–2)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02b#sec4-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Ezra’s Horrified Reaction (9:3–5)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02c#sec4-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. Ezra’s Prayer (9:6–15)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02c#sec3-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Ezra’s Action (10:1–44)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02c#sec4-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. Confession (10:1–4)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02c#sec4-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Oath (10:5–8)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02c#sec4-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. Assembly in the Rain (10:9–15)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02c#sec4-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d. Investigation of Intermarriage Cases and Expulsion (10:16–17)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02c#sec4-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("e. List of Offenders and Expulsion of Wives (10:18–44)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02c#sec5-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(1) Temple Personnel (10:18–24)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02c#sec5-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(2) Laity (10:25–44)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02#pt-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE BOOK OF NEHEMIAH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TEXT AND COMMENTARY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I. N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EHEMIAH")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EBUILDS THE")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALL OF")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ERUSALEM")]), _vm._v(" (1:1–6:19)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec2-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Report of Jerusalem in Distress (1:1–3)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec2-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Nehemiah’s Reaction (1:4–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Mourning (1:4)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Prayer (1:5–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec2-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. Artaxerxes Commissions Nehemiah (2:1–10)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Nehemiah Blurts Out His Problem to the King (2:1–3)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The King Approves and Supports Nehemiah’s Journey to Jerusalem (2:4–9)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Opposition from Sanballat and Tobiah (2:10)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec2-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D. Nehemiah Surveys the Wall (2:11–20)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Private Inspection by Night (2:11–15)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Meeting with Local Jewish Leaders (2:16–18)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Dealing with Opposition (2:19–20)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec2-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E. The Leaders and Their Crews Rebuild the Wall in Sections (3:1–32)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Priests Rebuild the Northern End (3:1)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Reconstruction of the Northern and Western Sections (3:2–15)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Reconstruction of the Eastern Section (3:16–27)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Further Repairs to the Eastern Section (3:28–32)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec2-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F. External Opposition to the Building Project (4:1–23 [3:33–4:17])")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Scoffing from Sanballat and Tobiah (4:1–3 [3:33–35])")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Nehemiah’s Prayer and Enclosure of the Wall (4:4–6 [3:36–38])")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Threats and Discouragement (4:7–12[1–6])")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Nehemiah Provides Military Protection, and the Builders Bear Arms (4:13–23[7–17])")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec2-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("G. Internal Oppression (5:1–19)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Complaint of Oppression by Fellow Jews (5:1–5)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Nehemiah Accuses Creditors of Abusing Kinship Bonds and Orders Restoration (5:6–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Creditors Swear to Obey Nehemiah’s Order in a Public Ceremony (5:12–13)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Nehemiah’s Selfless Devotion to the Project and the People (5:14–19)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec2-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("H. Sanballat, Tobiah, and Geshem Attempt to Destroy Nehemiah (6:1–19)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. A Plot to Lure Nehemiah away from the Jobsite (6:1–9)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. An Attempt to Lock Nehemiah in the Temple by Engaging False Prophecy (6:10–14)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Completion of the Wall Despite Opposition (6:15–16)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Intimidation Through Tobiah’s Family Network (6:17–19)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ESTORING THE")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLY")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMMUNITY")]), _vm._v(" (7:1–13:31)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec2-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Setting a Guard for Jerusalem (7:1–3)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec2-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Registering the People (7:4–73a[4–72a])")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Planning for the Repopulation of Jerusalem (7:4–5)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Returnees by Descent (7:6–25)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Returnees by City (7:26–38)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Temple and Related Personnel (7:39–60)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Undocumented Israelites/Priests (7:61–65)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Total Returnees and Animals (7:66–69[66–68])")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03a#sec3-62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Financial Donations and Conclusion (7:70–73a[69–72a])")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec2-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. Teaching, Celebrating, and Observing the Law (7:73b–8:18 [7:72b–8:18])")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec3-63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Ezra Reads the Law (7:73b–8:4 [7:72b–8:4])")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec3-64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. People Worship (8:5–6)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec3-65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Levites Teach the Law (8:7–8)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec3-66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. People Celebrate (8:9–12)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec3-67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The Festival of Booths (8:13–18)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec2-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D. Covenant Renewal (9:1–10:39)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec3-68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Confession (9:1–3)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec3-69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The Levites’ Penitential Prayer on Behalf of the Community (9:4–37)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec3-70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The Solemn Oath (9:38–10:39 [10:1–10:40])")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec4-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. Introduction (9:38 [10:1])")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec4-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Signatories (10:1–27[2–28])")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec4-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. Stipulations (10:28–39[29–40])")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec2-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E. Resettlement of Jerusalem (11:1–36)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec3-71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Casting Lots to Repopulate the City (11:1–2)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec3-72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. List of Residents (11:3–36)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec4-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. Lay Families (11:3–9)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec4-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Priestly Families (11:10–14)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec4-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. Levites and Gatekeepers (11:15–24)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec4-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d. Residents Outside of Jerusalem (11:25–36)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec5"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec5-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(1) Judah (11:25–30)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec5"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03b#sec5-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(2) Benjamin (11:31–36)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec2-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F. Temple Personnel (12:1–26)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec3-73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Priests and Levites During Zerubbabel’s Time (12:1–9)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec3-74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The Line of High Priests (12:10–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec3-75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Priests in Joiakim’s Day (12:12–21)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec3-76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Leaders of Families of Levites (12:22–26)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec2-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("G. The Dedication of the Wall of Jerusalem (12:27–47)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec3-77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Preparation (12:27–30)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec3-78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Processions (12:31–43)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec3-79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Worship (12:44–47)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec2-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("H. Nehemiah’s Reforms (13:1–31)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec3-80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Excluding Foreigners (13:1–3)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec3-81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Expelling Tobiah from the Temple (13:4–9)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec3-82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Reinstating Tithes for Levites (13:10–14)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec3-83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Sanctifying the Sabbath (13:15–22)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec3-84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Dealing with Intermarriage (13:23–29)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03c#sec3-85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Nehemiah’s Summary and Prayer (13:30–31)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4290e24c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005_Contents.vue
// module id = 69
// module chunks = 0